export default "__VITE_ASSET__C0XsV_TR__"